import * as React from 'react';

interface ExportTimerange {
  first: string;
  last: string;
}
const ExportTimerangeContext = React.createContext<ExportTimerange | undefined>(undefined);

export default ExportTimerangeContext;
